import "./Locks.css";

import { LockMark } from "../models/LockDTO";
import { lockBadgeTitle } from "../utils/lockMarks";

interface ILockBadgeProps {
    mark: LockMark | undefined;
    className?: string;
}

/** 🔒 next to a locked page wherever it is listed; lighter when the lock sits on an ancestor (whose title is the hover text). */
export function LockBadge(props: ILockBadgeProps) {
    if (!props.mark) return null;
    const title = lockBadgeTitle(props.mark);
    const css = ["lock-badge", props.mark.own ? "" : "inherited", props.className ?? ""].filter(Boolean).join(" ");
    return (
        <span className={css} role="img" aria-label={title} title={title}>
            {"\u{1F512}"}
        </span>
    );
}
